import React from 'react';
import AdminCardSection from '../../SuperAdmin/dashboard-components/AdminCardSection';

const SuperAdmin = () => {
  return (
    <div className='p-9'>
      <div className='grid grid-cols-2'>
        <AdminCardSection />
      </div>
    </div>
  );
};

export default SuperAdmin;
